import React, { useEffect } from 'react';
import { withTheme } from 'styled-components';

import LineupMatchupDataContainer from '../LineupMatchup/containers/LineupMatchupDataContainer';
import PreviewInfoDataContainer from '../PreviewInfo/containers/PreviewInfoDataContainer';
import useTracking from '../../utils/hooks/useTracking';

import {
    PreviewLineupMatchupWrapper,
    PreviewSubWrapper,
    PreviewWrapper,
    ProbablePitchersFollowWrapper,
    StyledCard
} from './Preview.style';
import PreviewGameInfo from './components/PreviewGameInfo';

const Preview = () => {
    const Tracking = useTracking();
    useEffect(() => {
        Tracking.track.track_pageload();
    }, [Tracking]);

    return (
        <PreviewWrapper>
            <StyledCard><PreviewInfoDataContainer /></StyledCard>
            <PreviewSubWrapper>
                <ProbablePitchersFollowWrapper>
                    <PreviewGameInfo />
                </ProbablePitchersFollowWrapper>
                <PreviewLineupMatchupWrapper>
                    <LineupMatchupDataContainer />
                </PreviewLineupMatchupWrapper>
            </PreviewSubWrapper>
        </PreviewWrapper>
    );
};

export default withTheme(Preview);
